"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var UI_1 = require("./UI");
var sidecar_1 = require("./sidecar");
var RequireSideCar = function (props) {
    return React.createElement(sidecar_1.default, tslib_1.__assign({}, props));
};
exports.FocusOn = React.forwardRef(function (props, ref) { return React.createElement(UI_1.FocusOn, tslib_1.__assign({}, props, { ref: ref, sideCar: RequireSideCar })); });



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es5/Combination.js
// module id = 666
// module chunks = 0